import { ButtonVariant, ModalConfirmButton } from '@dreryk/react-components';

import { useFormsTemplatesDisplayContext } from '../displayContext/formsTemplatesDisplayContext';
import { useFormsTemplatesContext } from '../formsTemplatesContext';
import { formsTemplatesTranslationKeys } from '../translations';

type FormsTemplatesAddNewItemButtonProps = {
   readonly variant?: ButtonVariant;
};

export const FormsTemplatesAddNewItemButton = (props: FormsTemplatesAddNewItemButtonProps): JSX.Element | null => {
   const { addNewItem, mode } = useFormsTemplatesContext();
   const displayContext = useFormsTemplatesDisplayContext();

   if (displayContext !== 'MODAL' || mode !== undefined) {
      return null;
   }

   return (
      <ModalConfirmButton
         label={formsTemplatesTranslationKeys.addTemplate}
         onClick={addNewItem}
         variant={props.variant}
      />
   );
};
